import api from './axios';

// PASS 시작
export const startPassAuth = async (payload) => {
  const { data } = await api.post("/auth/pass/start", payload);
  return data;
}

// PASS 결과 폴링
export const getPassResult = async (txId) => {
  const { data } = await api.get("/auth/pass/result", { params: { txId } });
  return data;
}

// 이메일 발송
export const sendEmailCode = async (userEmail, name) => {
  const { data } = await api.post("/knouComm/api/auth/send-otp", null, { params: { userEmail, name } });
  return data;
}
// 이메일 인증
export const verifyEmailCode = async (userEmail, otpCode) => {
  const { data } = await api.post("/knouComm/api/auth/verify-otp", null, { params: { userEmail, otpCode } });
  return data;
}

// 기관 검색
export const searchInstitutes = async (query, page = 0, size = 10) => {
  const { data } = await api.get("/institutes", { params: { q: query, page, size } });
  return data;
}

// 간편연계(sns) 회원체크
export const snsMemberCheck = async (memberInfo) => {
  const response = await api.get("/knouUser/member/getSnsMemberCheck", { params: memberInfo });
  return response.data;
}

// 본인인증 회원체크
export const phoneMemberCheck = async (memberInfo) => {
  const response = await api.get("/knouUser/member/getPhoneMemberCheck", { params: memberInfo });
  return response.data;
}

// 이메일 회원체크
export const getEmailCheck = async (memberInfo) => {
  const response = await api.get("/knouUser/member/getEmailCheck", { params: memberInfo });
  return response.data;
}

// 최종 가입
export const submitSignUp = async (memberInfo) => {
  const response = await api.post("/knouUser/member/insertMember", memberInfo);
  return response.data;
}

// csv파일로 등록된 정보 조회
export const uploadDataInfo = async (info) => {
  const response = await api.get('/knouUser/member/getUploadDataInfo', {params: info});
  return response.data;
};
